import {
  getClickCancelOOPModalEvent,
  getClickContinueOOPModalEvent,
  getEarnTag,
  getShowOOPModalEvent,
  isCaponeTenant,
  isCorpTenant,
  localCache,
  useShowPolicyBanner,
  wishlistsApi,
} from "@capone/common";
import { STAYS_WISHLIST } from "@capone/experiments";
import { Box, IconButton, Link, Tooltip, Typography } from "@material-ui/core";
import { InfoOutlined } from "@material-ui/icons";
import clsx from "clsx";
import dayjs from "dayjs";
import {
  ActionLink,
  CloseButtonIcon,
  CorpCompareBarBanner,
  CorpCompareBarTooltip,
  CorpPolicyBanner,
  GenericShopListFooter,
  HomeAvailabilityCard,
  HotelAvailabilityCard,
  HotelInformationalBanner,
  Icon,
  IconName,
  MobilePopoverCard,
  MultiroomSuffixText,
  OnSaleBanner,
  OutOfPolicyModal,
  PremierCollectionAvailabilityCard,
  PremierCollectionBenefitsModal,
  TravelSalesEventBanner,
  getIsFreeBreakfast,
  getNthNightBannerText,
  textConstants as halifaxTextConstants,
  useDeviceTypes,
  useForceUpdateAfterFirstRender,
  usePrevious,
  isSpendAndGetOffer,
} from "halifax";
import isEqual from "lodash-es/isEqual";
import queryStringParser from "query-string";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { InView } from "react-intersection-observer";
import ReactList from "react-list";
import { useSelector } from "react-redux";
import { RouteComponentProps } from "react-router";
import {
  CorpLodging,
  CorpLodgingData,
  ENGAGED_OFFER_CTA,
  HotelStarRatingEnum,
  IIdLodgings,
  Lodging,
  LodgingCollectionEnum,
  LodgingSelectionEnum,
  ModalScreens,
  POLICY_DESCRIPTOR,
  PolicyDescriptorEntryPoints,
  RewardsCurrency,
  SELECTED_HOTEL_FROM_LIST,
  SELECTED_TRAVEL_OFFER,
  SELECTED_UNAVAILABLE_HOTEL_FROM_LIST,
  SelectedTravelOfferScreen,
  VIEWED_LODGING_IN_LIST,
  VIEWED_OFFER_FAQ,
  VIEWED_POLICY_DESCRIPTOR,
  VIEWED_UNAVAILABLE_HOTEL_LIST,
  ViewedCorpRateDescriptorEntryPoints,
  buildEncodedPersistentLodgingTrackingProperties,
  getLodgingTrackingProperties,
  getStaysTabTrackingProperty,
  nthNightPromotion,
} from "redmond";
import {
  HotelDetailsEntrySourceEnum,
  LodgingPromotionType,
  StayType,
} from "redmond/hotels-module/interfaces";
import { v4 as uuidv4 } from "uuid";
import { ClientContext } from "../../../../App";
import { config } from "../../../../api/config";
import { trackEvent } from "../../../../api/v0/analytics/trackEvent";
import {
  AVAILABLE,
  CACHE_HOTEL_TOKEN,
  CONTROL,
  CORP_DEBUGGING_PANEL,
  CUSTOMER_PROFILE_EXPERIMENT,
  CUSTOMER_PROFILE_VARIANTS,
  DESKTOP_RECENTLY_VIEWED_HOTELS,
  DESKTOP_RECENTLY_VIEWED_HOTELS_VARIANTS,
  FREE_BREAKFAST_CANCEL,
  GLOBAL_MOBILE_NAV_EXPERIMENT,
  LC_GATING_EXPERIMENT,
  LODGING_PROMOTIONS,
  LODGING_PROMOTIONS_AVAILABLE,
  LODGING_PROMOTIONS_VARIANTS,
  MOBILE_RECENTLY_VIEWED_HOTELS,
  MOBILE_RECENTLY_VIEWED_HOTELS_VARIANTS,
  PREMIER_COLLECTION_EXPERIMENT,
  SHOW_MEALPLAN,
  STAYS_SEARCH,
  TRAVEL_SALE,
  TRAVEL_SALE_ACTIVE,
  TRAVEL_SALE_VARIANTS,
  TRAVEL_WALLET_OFFER_EXPERIMENT,
  XMOD_V1_EXPERIMENT,
  LUXURY_PAY_AT_HOTEL_BADGE,
  ALLOWED_PAY_LATER_LODGINGS,
  AllowedPayLaterLodgingsConfig,
  getExperimentVariant,
  getExperimentVariantCustomVariants,
  getExperimentVariantJSON,
  useExperiments,
} from "../../../../context/experiments";
import { isAllowedPayLaterLodging } from "../../../../utils/payLater";
import { onOpenCompareBarTooltip } from "../../../../utils/events";
import {
  PATH_AVAILABILITY,
  PATH_HOME,
  PATH_HOME_STAYS,
  PATH_SHOP,
  PATH_TRAVEL_SALE,
  PATH_VACATION_RENTAL_SHOP,
  PREMIER_COLLECTION_PATH_SHOP,
  PREMIER_PATH_VACATION_RENTALS_SHOP,
} from "../../../../utils/paths";
import { DesktopCalendarPicker } from "../../../search/components/HotelSearchControl/components/DesktopCalendarPicker";
import { MobileCalendarPicker } from "../../../search/components/MobileHotelSearchControl/components";
import {
  transformToStringifiedAvailabilityQuery,
  transformToStringifiedQuery,
} from "../../../shop/utils/queryStringHelpers";
import { TravelWalletDetailsBanner } from "../../../travel-wallet/components/TravelWalletDetailsBanner";
import { ConnectedWishlistAvailabilitySearch } from "../../../wishlist/components/WishlistAvailabilitySearch/container";
import { WishlistToggleHeart } from "../../../wishlist/components/WishlistToggleHeart/component";
import { HotelAvailabilityCallState } from "../../reducer/state";
import {
  TRAVEL_SALES_EVENT_ACTIVE_CTA,
  TRAVEL_SALES_EVENT_ACTIVE_SUBTITLE,
} from "../../textConstants";
import { AvailabilityNoResults } from "../AvailabilityNoResults";
import { AvailabilitySearchControl } from "../AvailabilitySearchControl";
import { AvailabilitySort } from "../AvailabilitySort";
import { CorporateDebuggingPanel } from "../CorporateDebuggingPanel";
import { StayTypeFilterControl } from "../StayTypeFilterControl";
import {
  getIsVacationRentalOnlyStayTypeSelected,
  getStayTypeFilterConfig,
} from "../utilities";
import { AvailabilityListConnectorProps } from "./container";
import "./styles.scss";
import * as textConstants from "./textConstants";
import { isLodgingRecommendedBasedOnPreferences } from "./utils";
const APPROXIMATE_HOTEL_AVAILABILITY_CARD_HEIGHT = 284;

export interface IAvailabilityListProps
  extends AvailabilityListConnectorProps,
    RouteComponentProps {
  isWishlistMode?: boolean;
}

export const AvailabilityList = (props: IAvailabilityListProps) => {
  const {
    lodgings,
    setLodgingIdInFocus,
    setLodgingIdHovered,
    fetchMoreHotelAvailability,
    setOpenDatesModal,
    nightCount,
    searchedLocation,
    hotelAvailabilityCallState,
    accountReferenceId,
    hotelQueryParams,
    history,
    viewedHotelListProperties,
    isFilteredHotelAvailabilityLodgingsEmpty,
    hasViewedUnavailableHotel,
    setHasViewedUnavailableHotel,
    fromDate,
    untilDate,
    adultsCount,
    children,
    mapBounds,
    setMapBound,
    openDatesModal,
    setSelectedLodgingIndex,
    roomsCount,
    searchedRoomsCount,
    searchedPetsCount,
    credit,
    isVentureX,
    selectedAccount,
    largestValueAccount,
    setViewHotelsNearLocation,
    isSearchingMap,
    shouldApplyUserHotelPreferences,
    userHasSetHotelPreferences,
    userHotelPreferences,
    canEarnRewards,
    setIsPremierCollectionEnabled,
    setIsLifestyleCollectionEnabled,
    showPremiumStaysOnly,
    resetFilters,
    bestOverallOffer,
    sortOrder,
    availabilityResultsHasHomesAndHotels,
    stayTypes,
    allFilters,
    isWishlistMode,
  } = props;

  const [locationName, setLocationName] = React.useState("");
  const listRef = useRef<ReactList | null>(null);
  const divRef = useRef<HTMLDivElement | null>(null);
  const { isAutoApprovalEnabled, policies } = useContext(ClientContext);
  const { matchesMobile, matchesDesktop } = useDeviceTypes();
  const [showPolicyModal, setShowPolicyModal] = useState<string | null>(null);
  const [corpPolicyDescriptorViewCount, setCorpPolicyDescriptorViewCount] =
    useState(0);

  const expState = useExperiments();

  const isCorporateDebuggingPanelEnabled =
    getExperimentVariant(expState.experiments, CORP_DEBUGGING_PANEL) ===
    AVAILABLE;

  const travelWalletOffer = getExperimentVariant(
    expState.experiments,
    TRAVEL_WALLET_OFFER_EXPERIMENT
  );
  const isTravelWalletOfferExperiment = useMemo(
    () => travelWalletOffer === AVAILABLE,
    [travelWalletOffer]
  );

  const freeBreakfastCancel = getExperimentVariant(
    expState.experiments,
    FREE_BREAKFAST_CANCEL
  );
  const isFreeBreakfastCancelExperiment = useMemo(
    () => freeBreakfastCancel === AVAILABLE,
    [freeBreakfastCancel]
  );

  const showMealPlanExperiment = getExperimentVariant(
    expState.experiments,
    SHOW_MEALPLAN
  );
  const isShowMealPlanExperiment = useMemo(
    () => showMealPlanExperiment === AVAILABLE,
    [showMealPlanExperiment]
  );

  const lodgingPromotions = getExperimentVariantCustomVariants(
    expState.experiments,
    LODGING_PROMOTIONS,
    LODGING_PROMOTIONS_VARIANTS
  );
  const isLodgingPromotionsExperiment = React.useMemo(
    () => lodgingPromotions === LODGING_PROMOTIONS_AVAILABLE,
    [lodgingPromotions]
  );

  const isLifestyleCollectionEnabled =
    getExperimentVariant(expState.experiments, LC_GATING_EXPERIMENT) ===
    AVAILABLE;

  const isPremierCollectionEnabled =
    getExperimentVariant(
      expState.experiments,
      PREMIER_COLLECTION_EXPERIMENT
    ) === AVAILABLE;

  // redundancy since luxury vrs will not be returned from the backend unless the user is in the experiment
  const isLuxuryVRinStays = isLifestyleCollectionEnabled;

  const isRecentlyViewedHotelsDesktopExperiment =
    getExperimentVariantCustomVariants(
      expState.experiments,
      DESKTOP_RECENTLY_VIEWED_HOTELS,
      DESKTOP_RECENTLY_VIEWED_HOTELS_VARIANTS
    ) !== CONTROL;

  const isRecentlyViewedHotelsMobileExperiment =
    getExperimentVariantCustomVariants(
      expState.experiments,
      MOBILE_RECENTLY_VIEWED_HOTELS,
      MOBILE_RECENTLY_VIEWED_HOTELS_VARIANTS
    ) !== CONTROL;

  const showEarnEnhancement =
    !!selectedAccount &&
    !!selectedAccount.earn.hotelsMultiplier &&
    canEarnRewards;

  const travelSalesEventVariant = getExperimentVariantCustomVariants(
    expState.experiments,
    TRAVEL_SALE,
    TRAVEL_SALE_VARIANTS
  );

  const globalMobileNav = getExperimentVariant(
    expState.experiments,
    GLOBAL_MOBILE_NAV_EXPERIMENT
  );

  const showPolicyBanner = useShowPolicyBanner(policies);

  const isGlobalMobileNavExperiment = useMemo(
    () => globalMobileNav === AVAILABLE,
    [globalMobileNav]
  );

  const modalType = isAutoApprovalEnabled
    ? "out_of_policy_auto"
    : "out_of_policy_24hr_review";

  const isCustomerProfileExperiment =
    getExperimentVariantCustomVariants(
      expState.experiments,
      CUSTOMER_PROFILE_EXPERIMENT,
      CUSTOMER_PROFILE_VARIANTS
    ) !== CONTROL;

  const staysSearchEnabled =
    getExperimentVariant(expState.experiments, STAYS_SEARCH) === AVAILABLE;

  const isWishlistExperiment =
    getExperimentVariant(expState.experiments, STAYS_WISHLIST) === AVAILABLE;
  const isXmodRedesign =
    getExperimentVariant(expState.experiments, XMOD_V1_EXPERIMENT) ===
    AVAILABLE;
  const isPayAtHotelBadgeEnabled =
    getExperimentVariant(expState.experiments, LUXURY_PAY_AT_HOTEL_BADGE) ===
    AVAILABLE;

  const allowedPayLaterLodgingIds = React.useMemo(() => {
    const config = getExperimentVariantJSON(
      expState.experiments,
      ALLOWED_PAY_LATER_LODGINGS
    ) as AllowedPayLaterLodgingsConfig | null;
    return config?.data?.lodgingIds;
  }, [expState.experiments]);

  const {
    dedicatedStayTypeFilterButtonGroupEnabled,
    dedicatedStayTypeFilterEnabled,
  } = getStayTypeFilterConfig({
    experiments: expState.experiments,
    availabilityResultsHasHomesAndHotels,
    stayTypes,
  });

  const scrollListToTop = () => {
    // @ts-ignore - scrollParent is not defined in the type definition for ReactList
    if (typeof listRef?.current?.scrollParent?.scrollTo === "function") {
      // @ts-ignore
      listRef.current.scrollParent.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const previousFilters = usePrevious(allFilters);
  const previousStayTypes = usePrevious(stayTypes);

  useEffect(() => {
    if (dedicatedStayTypeFilterEnabled) {
      if (
        // On mobile, changing the filters should return the user to the top
        (matchesMobile && !isEqual(allFilters, previousFilters)) ||
        // On desktop only a change to the stay type filter will return the user to the top
        (!matchesMobile && !isEqual(stayTypes, previousStayTypes))
      ) {
        scrollListToTop();
      }
    }
  }, [matchesMobile, allFilters, stayTypes, dedicatedStayTypeFilterEnabled]);

  const cacheHotelTokenEnabled =
    getExperimentVariant(expState.experiments, CACHE_HOTEL_TOKEN) === AVAILABLE;

  const [untilProp, setUntilProp] = useState<Date | null>(null);
  const [fromProp, setFromProp] = useState<Date | null>(null);
  const [refetchFromCalendarModal, setRefetchFromCalendarModal] =
    useState(false);
  const [openBenefitsModal, setOpenBenefitsModal] = useState(false);
  const [isSearchTermLodging, setIsSearchTermLodging] = React.useState(false);
  // If search term is location (ex: Toronto) vs if search term is point of interest (ex: Toronto Zoo)
  const [isSearchTermPoint, setIsSearchTermPoint] = React.useState(false);
  const [benefitsModalVariant, setBenefitsModalVariant] = React.useState<
    | "premier-collection"
    | "lifestyle-collection-premium"
    | "lifestyle-collection-non-premium"
  >();

  // Hack for render multiple ReactLists properly. In the first rendering, the second list does not get the correct height of the first list.
  // Forcing a render right after the initial render makes the second list position properly.
  useForceUpdateAfterFirstRender();

  useEffect(() => {
    setIsPremierCollectionEnabled(isPremierCollectionEnabled);
  }, [isPremierCollectionEnabled]);

  useEffect(() => {
    setIsLifestyleCollectionEnabled(isLifestyleCollectionEnabled);
  }, [isLifestyleCollectionEnabled]);

  useEffect(() => {
    const [locationName] = searchedLocation?.label
      ? searchedLocation.label.split(",")
      : [];
    setLocationName(locationName);

    const placeTypes = searchedLocation
      ? (searchedLocation.id as IIdLodgings).lodgingSelection.placeTypes
      : [];

    setIsSearchTermLodging(placeTypes?.includes("lodging"));
    setIsSearchTermPoint(
      !placeTypes?.includes("locality") &&
        !placeTypes?.includes("political") &&
        !placeTypes?.includes("country")
    );
  }, [searchedLocation]);

  useEffect(() => {
    const parsedQueryStringPrimitive = queryStringParser.parse(
      history.location.search
    );
    setUntilProp(
      dayjs(parsedQueryStringPrimitive.untilDate as string).toDate()
    );
    setFromProp(dayjs(parsedQueryStringPrimitive.fromDate as string).toDate());
  }, [history.location.search]);

  useEffect(() => {
    if (location && fromDate && untilDate && refetchFromCalendarModal) {
      history.push(
        `${PATH_AVAILABILITY}${transformToStringifiedAvailabilityQuery(
          (searchedLocation?.id as IIdLodgings).lodgingSelection.searchTerm,
          fromDate,
          untilDate,
          adultsCount,
          children,
          roomsCount,
          searchedPetsCount,
          undefined
        )}`
      );

      mapBounds && setMapBound(null);
      setViewHotelsNearLocation(null);
      setRefetchFromCalendarModal(false);
    }
  }, [fromDate, untilDate]);

  const presentHotelInfoBanner = (nthNightPromotion?: nthNightPromotion) => {
    if (nthNightPromotion) {
      return (
        <HotelInformationalBanner
          content={
            <Tooltip
              title={
                <Typography className="tooltip-text">
                  {nthNightPromotion?.tooltipDescription}
                </Typography>
              }
              classes={{
                popper: "nth-night-tooltip-popper",
                tooltip: "nth-night-tooltip-text",
              }}
              disableFocusListener={false}
              aria-labelledby={nthNightPromotion?.tooltipDescription}
            >
              <Box className="nth-night-banner-content">
                <Typography className="nth-night-content-text">
                  {nthNightPromotion?.description}
                </Typography>
                <IconButton aria-labelledby="nth-night-info-label">
                  <Icon name={IconName.InfoCircle} />
                </IconButton>
              </Box>
            </Tooltip>
          }
          isMobile={matchesMobile}
          isMap={false}
          iconName={IconName.Sparkle}
          isXmodRedesign={isXmodRedesign}
        />
      );
    }
    return (
      <HotelInformationalBanner
        content={
          <Tooltip
            title={
              <Typography className="tooltip-text">
                {halifaxTextConstants.FREE_BREAKFAST_TOOLTIP}
              </Typography>
            }
            classes={{
              popper: "free-breakfast-tooltip-popper",
              tooltip: "free-breakfast-tooltip-text",
            }}
          >
            <Box className="free-breakfast-banner-content">
              <Typography className="free-breakfast-content-text">
                Free breakfast for cardholders
              </Typography>
              <Icon name={IconName.InfoCircle} />
            </Box>
          </Tooltip>
        }
        isMobile={matchesMobile}
        isMap={false}
        iconName={IconName.FreeBreakfast}
        isXmodRedesign={isXmodRedesign}
      />
    );
  };

  const isAvail = (curr: Lodging) =>
    typeof curr.available === "undefined" || curr.available;

  const favoritedLodgings = useSelector(
    wishlistsApi.endpoints.getAllWishlistItemsByUser.select()
  )?.data;

  const isFavorited = (curr: Lodging) => {
    return favoritedLodgings?.has(curr.lodging.id);
  };

  const sortedLodgings = useMemo(() => {
    // SORT
    const searchedLodgingSelection = (searchedLocation?.id as IIdLodgings)
      ?.lodgingSelection;

    if (
      searchedLodgingSelection &&
      searchedLodgingSelection.placeTypes?.includes("lodging")
    ) {
      const searchTermName = searchedLodgingSelection.searchTerm.split(",")[0];
      return lodgings
        .slice()
        .sort(
          (a, b) =>
            b.lodging.name.toLowerCase().indexOf(searchTermName.toLowerCase()) -
            a.lodging.name.toLowerCase().indexOf(searchTermName.toLowerCase())
        );
    }
    return lodgings;
  }, [lodgings, searchedLocation]);

  const renderEachLodging = (
    lodgingData: Lodging | CorpLodging,
    index: number
  ) => {
    const {
      isPreferred,
      isFreeCancel,
      lodging,
      price,
      bestPromotionThisLodging,
      lodgingCollection,
      bestOfferThisLodging,
      stayType,
      nthNightPromotion,
      isSponsored,
    } = lodgingData;
    const ventureXGating = isVentureX
      ? lodging.starRating === HotelStarRatingEnum.Four ||
        lodging.starRating === HotelStarRatingEnum.Five
      : true;
    const nonVentureXGating = !isVentureX
      ? [
          HotelStarRatingEnum.Three,
          HotelStarRatingEnum.Four,
          HotelStarRatingEnum.Five,
        ].includes(lodging.starRating)
      : true;
    const showOnSaleBanner =
      isLodgingPromotionsExperiment &&
      bestPromotionThisLodging &&
      !!bestPromotionThisLodging.discountPercentage &&
      bestPromotionThisLodging.discountPercentage > 0 &&
      bestPromotionThisLodging.discountAmount.amount > 5 &&
      bestPromotionThisLodging.promotionType ==
        LodgingPromotionType.DealOfTheDay &&
      ventureXGating &&
      nonVentureXGating &&
      lodgingData.lodging.tripAdvisorReviews &&
      lodgingData.lodging.tripAdvisorReviews.overallScore * 5 >= 3.5;

    const available =
      typeof lodgingData.available === "undefined"
        ? true
        : lodgingData.available;

    const showPremierCollection =
      (isPremierCollectionEnabled &&
        lodgingCollection === LodgingCollectionEnum.Premier) ||
      ((isPremierCollectionEnabled || isLifestyleCollectionEnabled) &&
        lodgingCollection === LodgingCollectionEnum.Lifestyle);

    const isHome = stayType === StayType.Homes;
    const isLuxuryHome = isHome && showPremierCollection && isLuxuryVRinStays;

    const containsFreeBreakfastOrNthNight =
      !matchesMobile &&
      isCaponeTenant(config.TENANT) &&
      showPremierCollection &&
      ((getIsFreeBreakfast(lodgingData?.price?.mealPlan?.kind) &&
        // Do not show the free breakfast for Premier hotels as the breakfast is always included for all of them
        lodgingCollection !== LodgingCollectionEnum.Premier) ||
        nthNightPromotion);

    if (!available && !hasViewedUnavailableHotel) {
      setHasViewedUnavailableHotel();
      trackEvent({
        eventName: VIEWED_UNAVAILABLE_HOTEL_LIST,
        ...viewedHotelListProperties,
      });
    }

    const hasPolicyCompliance = "corporateTravel" in lodging;
    const isInPolicy =
      hasPolicyCompliance &&
      (lodging.corporateTravel.policyCompliance.isInPolicy ?? true);
    const policyReasons = hasPolicyCompliance
      ? lodging.corporateTravel.policyCompliance.reasons
      : [];

    const onOpenPolicyDescriptor = () => {
      if (corpPolicyDescriptorViewCount <= 5) {
        trackEvent({
          eventName: VIEWED_POLICY_DESCRIPTOR,
          properties: {
            type: POLICY_DESCRIPTOR,
            entry_point: PolicyDescriptorEntryPoints.HOTELS_LIST,
            funnel: "hotels",
            policy_reason: policyReasons.join(", "),
          },
        });
        setCorpPolicyDescriptorViewCount((prevState) => prevState + 1);
      }
    };

    const lodgingRecommendedBasedOnPreferences =
      isCustomerProfileExperiment &&
      !shouldApplyUserHotelPreferences &&
      userHasSetHotelPreferences &&
      !!userHotelPreferences &&
      isLodgingRecommendedBasedOnPreferences(lodgingData, userHotelPreferences);

    const showCorpCompareBarBanner =
      matchesDesktop && Boolean(lodgingData.hasCorporateRates);

    return (
      <Link
        id={`availability-row-${index}`}
        className={clsx("availability-row", {
          unavailable: !available && !isHome,
          "nav-improvement": isGlobalMobileNavExperiment,
        })}
        component="button"
        key={lodging.id}
        onClick={() => {
          let params = transformToStringifiedQuery({
            lodgingId: lodging.id,
            ...(isWishlistMode
              ? {
                  lodgingSelection: {
                    LodgingSelection: LodgingSelectionEnum.LodgingIds,
                    lodgingIds: [lodging.id],
                  },
                  fromWishlistId: new URLSearchParams(
                    window.location?.search
                  ).get("id"),
                }
              : {
                  lodgingSelection: mapBounds
                    ? {
                        LodgingSelection: LodgingSelectionEnum.Location,
                        descriptor: mapBounds,
                      }
                    : (searchedLocation?.id as IIdLodgings).lodgingSelection,
                }),
            ...hotelQueryParams,
            selectedLodgingIndex: index,
            roomsCount: searchedRoomsCount,
            petsCount: searchedPetsCount,
            adultsCount: adultsCount,
            fromHotelAvailability:
              lodgingCollection === LodgingCollectionEnum.Premier ||
              lodgingCollection === LodgingCollectionEnum.Lifestyle
                ? true
                : undefined,
            recommendedBasedOnPreferences: lodgingRecommendedBasedOnPreferences,
            hotelDetailsEntrySource: isWishlistMode
              ? HotelDetailsEntrySourceEnum.FAVORITES_LIST
              : HotelDetailsEntrySourceEnum.LIST,
            shopToken: cacheHotelTokenEnabled
              ? price?.opaqueShopRequest
              : localCache.set(uuidv4(), price?.opaqueShopRequest || "").key,
            sortOrder,
            tabView: getStaysTabTrackingProperty(stayTypes),
            encodedPersistentLodgingTrackingProperties:
              buildEncodedPersistentLodgingTrackingProperties(lodgingData),
          });

          if (isHome && staysSearchEnabled) {
            // Vacation Rentals (Homes) uses listingId instead of lodgingId in the shop URL
            params = params.replace("lodgingId", "listingId");
          }

          const path =
            isHome && !isLuxuryHome && staysSearchEnabled
              ? PATH_VACATION_RENTAL_SHOP
              : isLuxuryHome
              ? PREMIER_PATH_VACATION_RENTALS_SHOP
              : lodgingCollection === LodgingCollectionEnum.Premier ||
                lodgingCollection === LodgingCollectionEnum.Lifestyle
              ? PREMIER_COLLECTION_PATH_SHOP
              : PATH_SHOP;
          if (available) {
            trackEvent({
              eventName: SELECTED_HOTEL_FROM_LIST,
              properties: {
                ...viewedHotelListProperties.properties,
                ...getLodgingTrackingProperties(lodgingData).properties,
                is_preferred_cot: isPreferred,
                lodging_row_index: index,
                tab_view: getStaysTabTrackingProperty(stayTypes),
                is_vr: isHome,
              },
              encryptedProperties: [
                ...viewedHotelListProperties.encryptedProperties,
                ...getLodgingTrackingProperties(lodgingData)
                  .encryptedProperties,
              ],
            });
            setSelectedLodgingIndex(index);

            if (hasPolicyCompliance && !isInPolicy) {
              trackEvent(
                getShowOOPModalEvent(
                  ModalScreens.HOTELS_AVAILABILITY,
                  "hotels",
                  modalType
                )
              );
              return setShowPolicyModal(`${path}${params}`);
            }
          } else {
            trackEvent({
              eventName: SELECTED_UNAVAILABLE_HOTEL_FROM_LIST,
              properties: {
                ...viewedHotelListProperties.properties,
                lodging_row_index: index,
              },
              encryptedProperties:
                viewedHotelListProperties.encryptedProperties,
            });
          }
          // For vacation rentals we allow the user to view the shop page even if the dates are unavailable.
          if (available || isHome) {
            if (matchesMobile)
              history.push(`${path}${params}`, { fromPage: location.pathname });
            else window.open(`${path}${params}`, "_blank");
          }
        }}
        onMouseEnter={() => {
          setLodgingIdHovered(lodging.id);
        }}
        onMouseLeave={() => setLodgingIdHovered(null)}
        onFocus={(event: any) => {
          if (
            event.target == document.getElementById(`availability-row-${index}`)
          )
            if (available) setLodgingIdInFocus(lodging.id);
        }}
      >
        <InView
          as="div"
          onChange={(inView) => {
            if (inView) {
              const nightlyTotalWithTaxesAndFees =
                lodgingData.price?.breakdown &&
                "taxesAndFees" in lodgingData.price?.breakdown
                  ? (lodgingData.price?.nightlyPrice.fiat.value || 0) +
                    (lodgingData.price?.breakdown.taxesAndFees?.fiat.value ||
                      0) /
                      (nightCount || 1)
                  : lodgingData.price?.nightlyPrice.fiat.value || 0;

              const searchedLodgingSelection = (
                searchedLocation?.id as IIdLodgings
              )?.lodgingSelection;

              let isSearchedLodging = false;

              if (
                searchedLodgingSelection &&
                searchedLodgingSelection.placeTypes?.includes("lodging")
              ) {
                const searchTermName =
                  searchedLodgingSelection.searchTerm.split(",")[0];

                isSearchedLodging =
                  lodgingData.lodging.name.startsWith(searchTermName);
              }
              trackEvent({
                eventName: VIEWED_LODGING_IN_LIST,
                properties: {
                  ...viewedHotelListProperties.properties,
                  ...getLodgingTrackingProperties(lodgingData).properties,
                  lodging_row_index: index,
                  lodging_id: lodging.id,
                  lodging_name: lodging.name,
                  lodging_tripadvisor_rating:
                    lodging.tripAdvisorReviews?.overallScore.toString(),
                  promotion_applicable:
                    lodgingData?.bestPromotionThisLodging?.promotionType,
                  is_preferred: lodgingData?.isPreferred,
                  is_available: lodgingData?.available,
                  google_place_id: searchedLodgingSelection?.placeId,
                  daily_owed_including_taxes_fees_usd:
                    nightlyTotalWithTaxesAndFees,
                  daily_owed_excluding_taxes_fees_usd:
                    lodgingData.price?.nightlyPrice.fiat.value,
                  is_compare_to_bar: showCorpCompareBarBanner,
                  is_searched: isSearchedLodging,
                  is_vr: isHome,
                  is_favorited: isFavorited(lodgingData),
                  free_cancellation_shown: lodgingData.isFreeCancel,
                  check_in_date: fromDate
                    ? dayjs(fromDate).format("YYYY-MM-DD")
                    : undefined,
                  check_out_date: untilDate
                    ? dayjs(untilDate).format("YYYY-MM-DD")
                    : undefined,
                  los:
                    fromDate && untilDate
                      ? dayjs(untilDate).diff(fromDate, "day")
                      : undefined,
                  tab_view: getStaysTabTrackingProperty(stayTypes),
                  has_reviews: isHome
                    ? (lodgingData.homesListingDetails?.listingContent?.homesUserRating?.numberOfReviews ?? 0) > 0
                    : undefined,
                },
                encryptedProperties: [
                  // order matters, make we pass viewedHotelListProperties first and then getLodgingTrackingProperties
                  ...viewedHotelListProperties.encryptedProperties,
                  ...getLodgingTrackingProperties(lodgingData)
                    .encryptedProperties,
                ],
              });
            }
          }}
          threshold={0.8}
        >
          {containsFreeBreakfastOrNthNight ? (
            presentHotelInfoBanner(nthNightPromotion)
          ) : !matchesMobile && showOnSaleBanner ? (
            <OnSaleBanner
              salePercentage={
                bestPromotionThisLodging!.discountPercentage! * 100
              }
            />
          ) : null}
          <Box
            className={clsx("hotel-availability-card-wrapper", {
              unavailable: !available && !isHome,
              "on-sale": showOnSaleBanner,
              "premier-collection": showPremierCollection,
              "capone-corporate": isCorpTenant(config.TENANT),
              "show-policy-banner": showPolicyBanner,
              "has-corp-compare-banner": showCorpCompareBarBanner,
              "in-policy": showPolicyBanner && isInPolicy,
              "is-home": isHome,
              "free-breakfast":
                isCaponeTenant(config.TENANT) &&
                lodgingCollection === LodgingCollectionEnum.Lifestyle &&
                getIsFreeBreakfast(price?.mealPlan?.kind),
              "nth-night": nthNightPromotion && isCorpTenant(config.TENANT) && matchesDesktop,
            })}
          >
            <CorpPolicyBanner
              variant={matchesDesktop ? "descriptor" : "base"}
              productType={isHome ? "home" : "hotel"}
              corporateTravel={
                showPolicyBanner
                  ? (lodging as CorpLodgingData)?.corporateTravel
                  : undefined
              }
              limit={policies?.hotels.policies[0].maxPricePerNight}
              onOpen={() => onOpenPolicyDescriptor()}
              {...(matchesMobile && { borderRadius: 0 })}
            />
            <CorpCompareBarBanner
              show={showCorpCompareBarBanner}
              roundedTopCorners={!showPolicyBanner}
              onOpen={onOpenCompareBarTooltip(
                ViewedCorpRateDescriptorEntryPoints.HOTELS_LIST_CARD
              )}
            />
            {nthNightPromotion && isCorpTenant(config.TENANT) && matchesDesktop && (
              <HotelInformationalBanner
                content={
                  <Tooltip
                    title={
                      <Typography className="tooltip-text">
                        {nthNightPromotion.tooltipDescription}
                      </Typography>
                    }
                    classes={{
                      popper: "nth-night-tooltip-popper",
                      tooltip: "nth-night-tooltip-text",
                    }}
                  >
                    <Box className="nth-night-banner-content">
                      <Typography className="nth-night-content-text">
                        {getNthNightBannerText(nthNightPromotion)}
                      </Typography>
                      <Icon name={IconName.InfoCircle} />
                    </Box>
                  </Tooltip>
                }
                isMobile={false}
                isMap={false}
                iconName={IconName.Sparkle}
                position={
                  (showPolicyBanner && (lodging as CorpLodgingData)?.corporateTravel) || showCorpCompareBarBanner
                    ? "middle"
                    : "top"
                }
              />
            )}
            <Box className="hotel-availability-card-content">
              {isHome && !isLuxuryHome ? (
                <HomeAvailabilityCard
                  isMobile={matchesMobile}
                  isGlobalMobileNavExperiment={isGlobalMobileNavExperiment}
                  wishlistComponent={
                    isWishlistExperiment ? (
                      <WishlistToggleHeart
                        listingImageUrl={lodgingData.lodging.media?.[0]?.url}
                        stayType={StayType.Homes}
                        lodgingCollection={lodgingData.lodgingCollection}
                        style={{
                          position: "absolute",
                          top: "8px",
                          right: "8px",
                        }}
                        listingId={lodging.id}
                      />
                    ) : undefined
                  }
                  lodging={lodgingData}
                  nightCount={nightCount}
                  rewardsKey={accountReferenceId || undefined}
                  isInPolicy={isInPolicy}
                  earnTagContent={
                    showEarnEnhancement &&
                    !!selectedAccount.earn?.homesMultiplier ? (
                      <>
                        <Icon name={IconName.StarIcon} />
                        <Typography className="earn-tag-text">
                          {getEarnTag(
                            selectedAccount,
                            selectedAccount.rewardsBalance
                              .currency as RewardsCurrency,
                            "vacation rentals"
                          )}
                        </Typography>
                      </>
                    ) : undefined
                  }
                  isXmodRedesign={isXmodRedesign}
                />
              ) : showPremierCollection ? (
                <PremierCollectionAvailabilityCard
                  hotelAvailabilityInfo={{
                    nthNightPromotion,
                    bestOfferThisLodging:
                      bestOfferThisLodging &&
                      !isSpendAndGetOffer(bestOfferThisLodging.descriptions)
                        ? bestOfferThisLodging
                        : undefined,
                    bestPromotionThisLodging,
                    lodging,
                    price,
                    isFreeCancel,
                  }}
                  nightCount={nightCount}
                  rewardsKey={accountReferenceId || undefined}
                  available={available}
                  isLifestyleCollection={
                    (isPremierCollectionEnabled ||
                      isLifestyleCollectionEnabled) &&
                    lodgingCollection === LodgingCollectionEnum.Lifestyle
                  }
                  showRibbon
                  showHotelDetailsCTA={
                    isLuxuryHome && !matchesMobile && available
                  }
                  ctaText={
                    isLuxuryHome
                      ? textConstants.VIEW_HOME_DETAILS_TEXT
                      : undefined
                  }
                  isMobile={matchesMobile}
                  isXmodRedesign={isXmodRedesign}
                  isPayAtHotelBadgeEnabled={isPayAtHotelBadgeEnabled && isAllowedPayLaterLodging(allowedPayLaterLodgingIds, lodging.id)}
                  onBenefitsTooltipClick={() => {
                    setBenefitsModalVariant(
                      (() => {
                        if (
                          lodgingCollection === LodgingCollectionEnum.Lifestyle
                        ) {
                          if (isPremierCollectionEnabled)
                            return "lifestyle-collection-premium";
                          return "lifestyle-collection-non-premium";
                        }
                        return "premier-collection";
                      })()
                    );
                    setOpenBenefitsModal(true);
                  }}
                  showVRBenefits={isLuxuryHome}
                  showOffer={
                    isTravelWalletOfferExperiment &&
                    lodgingData.bestOfferThisLodging?.amount.amount !==
                      credit?.amount.amount &&
                    !(
                      lodgingData.bestOfferThisLodging &&
                      isSpendAndGetOffer(
                        lodgingData.bestOfferThisLodging.descriptions
                      )
                    )
                  }
                  className={
                    containsFreeBreakfastOrNthNight
                      ? nthNightPromotion
                        ? "nth-night"
                        : "free-breakfast"
                      : undefined
                  }
                  earnTagContent={
                    showEarnEnhancement ? (
                      <>
                        <Icon name={IconName.StarIcon} />
                        <Typography className="earn-tag-text">
                          {getEarnTag(
                            selectedAccount,
                            selectedAccount.rewardsBalance
                              .currency as RewardsCurrency,
                            isLuxuryHome ? "vacation rentals" : "hotels"
                          )}
                        </Typography>
                      </>
                    ) : undefined
                  }
                  earnTagClassName={showEarnEnhancement ? "b2b" : undefined}
                  tooltipContent={
                    !isLuxuryHome ? (
                      <>
                        <Box className="benefits-summary">
                          <Icon name={IconName.StarOutline} />
                          <Typography className="benefits-summary-text">
                            {textConstants.getBenefitsSummary(
                              lodgingCollection,
                              selectedAccount?.productDisplayName,
                              largestValueAccount.earn?.hotelsMultiplier,
                              selectedAccount?.customerAccountRole === "Primary"
                            )}
                          </Typography>
                        </Box>
                        <Box className="additional-benefits">
                          <Icon name={IconName.GiftOutline} />
                          <Typography className="additional-benefits-summary-text">
                            {textConstants.getAdditionalBenefitsSummary()}
                          </Typography>{" "}
                        </Box>
                      </>
                    ) : undefined
                  }
                  tenant={config.TENANT}
                  vrBenefitsTooltipContent={
                    <Box>
                      <Typography variant="subtitle2" className="tooltip-text">
                        {selectedAccount?.productDisplayName
                          ? `• Earn 5x on your ${
                              selectedAccount?.productDisplayName
                            } card and enjoy a $${
                              lodgingCollection ===
                              LodgingCollectionEnum.Lifestyle
                                ? 50
                                : 100
                            } Experience Credit to use during your stay`
                          : ""}
                      </Typography>
                      <Typography variant="subtitle2" className="tooltip-text">
                        • Plus, enjoy other premium benefits like early check-in
                        and late checkout when available
                      </Typography>
                    </Box>
                  }
                  vrBenefitsMobilePopoverContent={
                    <Box>
                      <Typography
                        variant="subtitle2"
                        className="mobile-vr-benefits-popover-content"
                      >
                        {selectedAccount?.productDisplayName
                          ? `• Earn 5x on your ${
                              selectedAccount?.productDisplayName
                            } card and enjoy a $${
                              lodgingCollection ===
                              LodgingCollectionEnum.Lifestyle
                                ? 50
                                : 100
                            } Experience Credit to use during your stay`
                          : ""}
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        className="mobile-vr-benefits-popover-content"
                      >
                        • Plus, enjoy other premium benefits like early check-in
                        and late checkout when available
                      </Typography>
                    </Box>
                  }
                  onOfferTooltipSetOpenModal={(open) => {
                    if (open) {
                      trackEvent({
                        eventName: ENGAGED_OFFER_CTA,
                        properties: {
                          location: SelectedTravelOfferScreen.HOTEL_SHOP,
                          entry_type: "tooltip",
                          funnel:
                            lodgingData.bestOfferThisLodging?.funnels.join(","),
                          offer_name:
                            lodgingData.bestOfferThisLodging
                              ?.trackingPropertiesV2?.properties?.offer_name,
                        },
                        encryptedProperties: [
                          lodgingData.bestOfferThisLodging?.trackingPropertiesV2
                            ?.encryptedProperties ?? "",
                        ],
                      });
                    }
                  }}
                  hideDailyBreakfastBenefit={isLuxuryHome}
                  homesListingDetails={
                    isLuxuryHome ? lodgingData.homesListingDetails : undefined
                  }
                  wishlistComponent={
                    isWishlistExperiment ? (
                      <WishlistToggleHeart
                        listingImageUrl={lodgingData.lodging.media?.[0]?.url}
                        style={{
                          position: "absolute",
                          top: "8px",
                          right: "8px",
                        }}
                        listingId={lodging.id}
                        stayType={lodgingData.stayType || StayType.Hotels}
                        lodgingCollection={lodgingData.lodgingCollection}
                      />
                    ) : undefined
                  }
                  isLuxuryHomeInStaysFunnel={isLuxuryHome}
                  hotelUnavailableTitleText={textConstants.getUnavailableText(
                    !isLuxuryHome
                  )}
                  showPolicyBanner={showPolicyBanner}
                  hideNthNightBanner={matchesDesktop}
                />
              ) : (
                <HotelAvailabilityCard
                  hotelAvailabilityInfo={{
                    nthNightPromotion,
                    bestPromotionThisLodging,
                    lodging,
                    price,
                    nightCount,
                    // TODO: ask about where to get city name only (e.g.: Toronto)
                    neighbourhood: searchedLocation?.label,
                    rewardsKey: accountReferenceId || undefined,
                    available: lodgingData.available,
                    bestOfferThisLodging:
                      lodgingData.bestOfferThisLodging &&
                      !isSpendAndGetOffer(
                        lodgingData.bestOfferThisLodging.descriptions
                      )
                        ? lodgingData.bestOfferThisLodging
                        : undefined,
                    lastViewed:
                      (!matchesMobile &&
                        isRecentlyViewedHotelsDesktopExperiment) ||
                      (matchesMobile && isRecentlyViewedHotelsMobileExperiment)
                        ? lodgingData.lastViewed
                        : undefined,
                    searchedRoomCount: searchedRoomsCount,
                    isSponsored,
                    highlights: lodgingData.highlights,
                    lodgingCollection: lodgingData.lodgingCollection,
                  }}
                  isPayAtHotelBadgeEnabled={isPayAtHotelBadgeEnabled && isAllowedPayLaterLodging(allowedPayLaterLodgingIds, lodging.id)}
                  isLoyaltyEligible={Boolean(lodgingData?.loyaltyProgramCode)}
                  hasCorporateRates={Boolean(lodgingData.hasCorporateRates)}
                  isMobile={matchesMobile}
                  isFreeCancel={isFreeCancel}
                  showOnSaleBanner={showOnSaleBanner}
                  onSaleAmount={
                    isLodgingPromotionsExperiment &&
                    bestPromotionThisLodging?.discountPercentage
                      ? bestPromotionThisLodging?.discountPercentage * 100
                      : undefined
                  }
                  isFreeBreakfastCancelExperiment={
                    isFreeBreakfastCancelExperiment
                  }
                  isShowMealPlanExperiment={isShowMealPlanExperiment}
                  className={clsx("b2b", { showPolicyBanner })}
                  showOffer={
                    isTravelWalletOfferExperiment &&
                    lodgingData.bestOfferThisLodging?.amount.amount !==
                      credit?.amount.amount &&
                    !(
                      lodgingData.bestOfferThisLodging &&
                      isSpendAndGetOffer(
                        lodgingData.bestOfferThisLodging.descriptions
                      )
                    )
                  }
                  onOfferTooltipSetOpenModal={(open) => {
                    if (open) {
                      trackEvent({
                        eventName: SELECTED_TRAVEL_OFFER,
                        properties: {
                          screen: SelectedTravelOfferScreen.HOTEL_SHOP,
                          ...lodgingData.bestOfferThisLodging
                            ?.trackingPropertiesV2?.properties,
                        },
                        encryptedProperties: [
                          lodgingData.bestOfferThisLodging?.trackingPropertiesV2
                            ?.encryptedProperties ?? "",
                        ],
                      });

                      trackEvent({
                        eventName: ENGAGED_OFFER_CTA,
                        properties: {
                          location: SelectedTravelOfferScreen.HOTEL_SHOP,
                          entry_type: "tooltip",
                          funnel:
                            lodgingData.bestOfferThisLodging?.funnels.join(","),
                          offer_name:
                            lodgingData.bestOfferThisLodging
                              ?.trackingPropertiesV2?.properties?.offer_name,
                        },
                        encryptedProperties: [
                          lodgingData.bestOfferThisLodging?.trackingPropertiesV2
                            ?.encryptedProperties ?? "",
                        ],
                      });
                    }
                  }}
                  onFirstTravelOfferCardChange={() => {
                    trackEvent({
                      eventName: VIEWED_OFFER_FAQ,
                      properties: {
                        screen: SelectedTravelOfferScreen.HOTEL_SHOP,
                      },
                    });
                  }}
                  suffixText={
                    <MultiroomSuffixText
                      roomsCount={searchedRoomsCount}
                      className="availability-suffix-text"
                    />
                  }
                  earnTagContent={
                    showEarnEnhancement ? (
                      <>
                        <Icon name={IconName.StarIcon} />
                        <Typography className="earn-tag-text">
                          {getEarnTag(
                            selectedAccount,
                            selectedAccount.rewardsBalance
                              .currency as RewardsCurrency,
                            "hotels"
                          )}
                        </Typography>
                      </>
                    ) : undefined
                  }
                  earnTagClassName={showEarnEnhancement ? "b2b" : undefined}
                  isTravelSale={travelSalesEventVariant === TRAVEL_SALE_ACTIVE}
                  isRecommendedBasedOnPreferences={
                    lodgingRecommendedBasedOnPreferences
                  }
                  isGlobalMobileNavExperiment={isGlobalMobileNavExperiment}
                  tenant={config.TENANT}
                  hideNthNightBanner={matchesDesktop}
                  wishlistComponent={
                    isWishlistExperiment ? (
                      <WishlistToggleHeart
                        listingId={lodging.id}
                        listingImageUrl={lodgingData.lodging.media?.[0]?.url}
                        stayType={StayType.Hotels}
                        lodgingCollection={lodgingData.lodgingCollection}
                        style={{
                          position: "absolute",
                          top: "8px",
                          right: "8px",
                        }}
                      />
                    ) : undefined
                  }
                />
              )}
            </Box>
          </Box>
        </InView>
      </Link>
    );
  };

  // note: the behaviour of having the car availability screen continuously making followUp requests is actually preferred;
  // please see the comment section on https://hopper-jira.atlassian.net/browse/BP-1519 for more info.
  useEffect(() => {
    if (
      hotelAvailabilityCallState ===
        HotelAvailabilityCallState.FollowUpSearchCallSuccess ||
      hotelAvailabilityCallState ===
        HotelAvailabilityCallState.InitialSearchCallSuccess
    ) {
      let shouldIncludeHomes = false;
      if (staysSearchEnabled) {
        shouldIncludeHomes = true;
      }
      setTimeout(
        () => fetchMoreHotelAvailability(history, shouldIncludeHomes),
        100
      );
    }
  }, [hotelAvailabilityCallState, fetchMoreHotelAvailability, history]);

  const [showWalletBanner, setShowWalletBanner] = useState(false);

  useEffect(() => {
    setShowWalletBanner(
      !staysSearchEnabled && // wallet banner is disabled for stays search to make room for the stay type filter.
        ((credit && credit.amount.amount < 0) || !!bestOverallOffer || false)
    );
  }, [credit, bestOverallOffer, dedicatedStayTypeFilterButtonGroupEnabled]);

  const containerRef = useRef<null | HTMLElement>(null);

  return (
    <Box
      className={clsx("availability-list-root", {
        mobile: matchesMobile,
      })}
      {...{ ref: containerRef }}
    >
      {isCorporateDebuggingPanelEnabled && (
        <CorporateDebuggingPanel lodgings={lodgings} />
      )}

      <PremierCollectionBenefitsModal
        openBenefitsModal={openBenefitsModal}
        handleClosePCBenefitsModal={() => {
          setOpenBenefitsModal(false);
        }}
        isMobile={matchesMobile}
        variant={benefitsModalVariant}
        useBenefitsSummary
        isUserPrimary={selectedAccount?.customerAccountRole === "Primary"}
        tenant={config.TENANT}
        largestValueAccount={largestValueAccount}
      />
      {showPolicyModal && (
        <OutOfPolicyModal
          isOpen={!!showPolicyModal}
          isMobile={matchesMobile}
          onClose={() => {
            setShowPolicyModal(null);
            trackEvent(
              getClickCancelOOPModalEvent(
                ModalScreens.HOTELS_AVAILABILITY,
                "hotels",
                modalType
              )
            );
          }}
          onContinue={() => {
            if (matchesMobile) {
              history.push(showPolicyModal, { fromPage: location.pathname });
            } else {
              window.open(showPolicyModal, "_blank");
            }
            setShowPolicyModal(null);
            trackEvent(
              getClickContinueOOPModalEvent(
                ModalScreens.HOTELS_AVAILABILITY,
                "hotels",
                modalType
              )
            );
          }}
          isApprovalRequired={
            policies?.settings && policies.settings.isApprovalRequired
          }
        />
      )}
      <Box className="availability-list-container">
        {showWalletBanner && (
          <TravelWalletDetailsBanner
            showButton={!matchesMobile}
            screen={SelectedTravelOfferScreen.HOTEL_SHOP}
            {...props}
            offer={bestOverallOffer}
            bannerTextType="availability"
            onDismiss={
              matchesMobile ? undefined : () => setShowWalletBanner(false)
            }
          />
        )}

        {dedicatedStayTypeFilterButtonGroupEnabled &&
          !matchesMobile &&
          !isWishlistMode && (
            <Box
              className={clsx("availability-list-stay-type-filter", {
                "travel-wallet-offer-visible": showWalletBanner,
              })}
            >
              <StayTypeFilterControl />
            </Box>
          )}

        {!matchesMobile ? (
          isWishlistMode ? (
            <ConnectedWishlistAvailabilitySearch />
          ) : (
            <AvailabilitySearchControl />
          )
        ) : null}

        {isCorpTenant(config.TENANT) &&
          !getIsVacationRentalOnlyStayTypeSelected(stayTypes) && (
            <Box
              className={clsx("availability-list-corp-bar-banner", {
                mobile: matchesMobile,
              })}
            >
              <Icon name={IconName.TagIcon} />
              <CorpCompareBarTooltip
                label={
                  <Typography>
                    {textConstants.CORP_COMPARE_TO_BAR_BANNER_TEXT}
                    {matchesMobile && <InfoOutlined fontSize="small" />}
                  </Typography>
                }
                additionalTooltipContent={
                  <Typography
                    style={{ fontStyle: "italic", marginTop: "10px" }}
                  >
                    Look for the price tag icon to find hotels with these rates!
                  </Typography>
                }
                onOpen={onOpenCompareBarTooltip(
                  ViewedCorpRateDescriptorEntryPoints.HOTELS_LIST_HEADER
                )}
                hideIcon={matchesMobile}
              />
            </Box>
          )}

        {!matchesMobile && (
          <Box className="availability-list-heading-sort">
            {locationName || isSearchingMap || isWishlistMode ? (
              <Typography
                variant="h4"
                className="availability-list-count-heading"
              >
                {textConstants.COUNT_HEADING_TEXT(
                  sortedLodgings.filter(isAvail).length,
                  locationName,
                  isSearchTermLodging,
                  isSearchTermPoint,
                  isSearchingMap,
                  staysSearchEnabled,
                  dedicatedStayTypeFilterEnabled,
                  stayTypes,
                  isWishlistMode
                )}
              </Typography>
            ) : (
              <div />
            )}
            <AvailabilitySort />
          </Box>
        )}

        {!matchesMobile && travelSalesEventVariant === TRAVEL_SALE_ACTIVE && (
          <TravelSalesEventBanner
            variant="default"
            onClick={() => {
              const path = `${PATH_TRAVEL_SALE}?entryType=hotel_list_component`;
              window.open(path, "_blank");
            }}
            subtitle={TRAVEL_SALES_EVENT_ACTIVE_SUBTITLE}
            buttonText={TRAVEL_SALES_EVENT_ACTIVE_CTA}
          />
        )}
        {isFilteredHotelAvailabilityLodgingsEmpty ? (
          <Box className="no-hotels-found-components-section">
            <AvailabilityNoResults />
          </Box>
        ) : (
          <div ref={divRef} className="availability-list">
            {/* TODO?: add search by lodging ids */}

            <ReactList
              ref={listRef}
              itemRenderer={(index: number) => {
                if (
                  hotelAvailabilityCallState ===
                  HotelAvailabilityCallState.InitialMapSearchCallInProcess
                ) {
                  return (
                    <HotelAvailabilitySkeleton
                      key={index}
                      isMobile={matchesMobile}
                    />
                  );
                }
                if (index < sortedLodgings.length) {
                  return (
                    <React.Fragment key={index}>
                      {renderEachLodging(sortedLodgings[index], index)}
                    </React.Fragment>
                  );
                }
                // render CardSkeleton when it's not Complete
                if (
                  hotelAvailabilityCallState !==
                  HotelAvailabilityCallState.Complete
                ) {
                  return (
                    <HotelAvailabilitySkeleton
                      key={index}
                      isMobile={matchesMobile}
                    />
                  );
                }
                // render MoreResults footer when it's Complete
                if (
                  hotelAvailabilityCallState ===
                  HotelAvailabilityCallState.Complete
                ) {
                  if (isWishlistMode) {
                    return <></>;
                  }
                  return (
                    <>
                      {matchesMobile ? (
                        <MobilePopoverCard
                          open={openDatesModal}
                          onClose={() => setOpenDatesModal(false)}
                          fullScreen
                          className="mobile-dates-selection-root"
                          contentClassName="mobile-dates-selection-content-wrapper"
                          topRightButton={
                            <ActionLink
                              className="dates-selection-close-button"
                              content={<CloseButtonIcon />}
                              label="Close"
                              onClick={() => setOpenDatesModal(false)}
                            />
                          }
                        >
                          <Box className="mobile-dates-selection-content-container">
                            <MobileCalendarPicker
                              onComplete={() => {
                                setOpenDatesModal(false);
                              }}
                            />
                          </Box>
                        </MobilePopoverCard>
                      ) : (
                        <DesktopCalendarPicker
                          open={openDatesModal}
                          closePopup={() => {
                            setOpenDatesModal(false);
                          }}
                          fromProp={fromProp}
                          untilProp={untilProp}
                          onClickDone={() => {
                            setRefetchFromCalendarModal &&
                              setRefetchFromCalendarModal(true);
                          }}
                        />
                      )}
                      <GenericShopListFooter
                        className={clsx(
                          "availability-list-find-more-results",
                          "b2b"
                        )}
                        title={
                          showPremiumStaysOnly
                            ? textConstants.PREMIUM_STAYS_FIND_MORE_RESULTS_TITLE_TEXT
                            : textConstants.FIND_MORE_RESULTS_TITLE_TEXT(
                                staysSearchEnabled
                              )
                        }
                        subtitle={
                          showPremiumStaysOnly
                            ? textConstants.PREMIUM_STAYS_FIND_MORE_RESULTS_SUBTITLE_TEXT
                            : textConstants.FIND_MORE_RESULTS_SUBTITLE_TEXT(
                                staysSearchEnabled
                              )
                        }
                        buttons={
                          showPremiumStaysOnly
                            ? [
                                {
                                  title:
                                    textConstants.CLEAR_FILTERS_AND_SEARCH(
                                      staysSearchEnabled
                                    ),
                                  className: clsx(
                                    "find-more-results-button",
                                    "adjust-dates",
                                    "b2b"
                                  ),
                                  isPrimary: true,
                                  onClick: () => {
                                    resetFilters();
                                    const scrollContainer =
                                      containerRef.current?.parentElement;
                                    scrollContainer?.scrollTo({
                                      top: 0,
                                      behavior: "smooth",
                                    });
                                  },
                                },
                              ]
                            : [
                                {
                                  title: textConstants.ADJUST_DATES_TEXT,
                                  className: clsx(
                                    "find-more-results-button",
                                    "adjust-dates",
                                    "b2b"
                                  ),
                                  isPrimary: true,
                                  onClick: () => setOpenDatesModal(true),
                                },
                                {
                                  title: textConstants.SEARCH_AGAIN_TEXT,
                                  className: clsx(
                                    "find-more-results-button",
                                    "search-again",
                                    "b2b"
                                  ),
                                  isPrimary: false,
                                  onClick: () => {
                                    const path = staysSearchEnabled
                                      ? PATH_HOME_STAYS
                                      : PATH_HOME;
                                    history.push(path);
                                  },
                                },
                              ]
                        }
                        isMobile={matchesMobile}
                      />
                    </>
                  );
                }

                return <></>;
              }}
              length={sortedLodgings.length + (isWishlistMode ? 0 : 1)}
              type="variable"
              itemSizeEstimator={() =>
                APPROXIMATE_HOTEL_AVAILABILITY_CARD_HEIGHT
              }
            />
          </div>
        )}
      </Box>
    </Box>
  );
};

interface IHotelAvailabilitySkeletonProps {
  isMobile: boolean;
}

const HotelAvailabilitySkeleton = (props: IHotelAvailabilitySkeletonProps) => {
  const { isMobile } = props;

  return (
    <Box className="availability-skeleton-row">
      <Box className="hotel-availability-card-wrapper">
        <HotelAvailabilityCard isSkeleton isMobile={isMobile} />
      </Box>
    </Box>
  );
};
